
import { defineComponent, PropType } from 'vue'
import { TGroup } from '@/types'
import GroupItem from './GroupItem.vue'
import { ActionBtn } from '../ActionBtn'

export default defineComponent({
  name: 'GroupList',
  components: {
    GroupItem,
    ActionBtn
  },
  props: {
    list: {
      type: Array as PropType<TGroup[]>
    }
  },
  data () {
    return {
      showTopBtn: false,
      showBottomBtn: false
    }
  },
  mounted () {
    this.initEvent()
  },
  methods: {
    initEvent () {
      const { $el: el } = this
      el.addEventListener('scroll', () => {
        this.showTopBtn = el.scrollTop === 0
        this.showBottomBtn = el.scrollHeight - el.scrollTop === el.clientHeight
      })
    }
  }
})
